// client/src/components/TiptapEditor/MenuBar/FontFamilyGroup.js
import React, { useCallback } from "react";

export const FontFamilyGroup = ({ editor }) => {
  const handleFontChange = useCallback(
    (e) => {
      const fontFamily = e.target.value;
      if (fontFamily === "default") {
        // Si el usuario elige la opción por defecto, quitamos el estilo de fuente
        editor.chain().focus().unsetFontFamily().run();
      } else {
        // Si elige otra fuente, la aplicamos
        editor.chain().focus().setFontFamily(fontFamily).run();
      }
    },
    [editor],
  );

  // Obtenemos la fuente actual para que el selector muestre el valor correcto
  const activeFont = editor.getAttributes("textStyle").fontFamily || "default";

  return (
    <select value={activeFont} onChange={handleFontChange}>
      <option value="default">Fuente Por Defecto</option>
      <option value="Roboto">Roboto</option>
      {/* Aquí podríamos añadir más fuentes en el futuro */}
    </select>
  );
};
